import { STORE_USER_LANGUAGE, STORE_TRANSLATIONS } from '../types';

export const storeUserLanguage = language => ({
  type: STORE_USER_LANGUAGE,
  language,
});

export const storeTranslations = (translationsCache, lastCacheTime) => ({
  type: STORE_TRANSLATIONS,
  translationsCache,
  lastCacheTime,
});
